<div class="loader-container" *ngIf="loaderService.loader > 0">
  <mat-spinner mode="indeterminate"></mat-spinner>
</div>
